// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { FamilyCreditRequest } from './family-credit-request';

// @ts-ignore
import { FamilyRefundRequest } from './family-refund-request';

// @ts-ignore
import { InsuranceRefundRequest } from './insurance-refund-request';

// @ts-ignore
import { PatientCreditRequest } from './patient-credit-request';

// @ts-ignore
import { PatientRefundRequest } from './patient-refund-request';

/** See com.rev360.pms.api.controller.accounting.GrantCreditsRequest */
/* istanbul ignore next */
@GandalfModel
export class GrantCreditsRequest extends GandalfModelBase {

	@GandalfLabel('Family Credit')
	@GandalfProperty({ designType: FamilyCreditRequest })
	familyCredit!: FamilyCreditRequest | null;

	@GandalfLabel('Family Refund')
	@GandalfProperty({ designType: FamilyRefundRequest })
	familyRefund!: FamilyRefundRequest | null;

	@GandalfLabel('Insurance Refund')
	@GandalfProperty({ designType: InsuranceRefundRequest })
	insuranceRefund!: InsuranceRefundRequest | null;

	@GandalfLabel('Invoice')
	@GandalfValidator({ notNull: { message: 'Invoice is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	invoiceId!: number;

	@GandalfLabel('Patient Credit')
	@GandalfProperty({ designType: PatientCreditRequest })
	patientCredit!: PatientCreditRequest | null;

	@GandalfLabel('Patient Refund')
	@GandalfProperty({ designType: PatientRefundRequest })
	patientRefund!: PatientRefundRequest | null;

}
